export default __webpack_public_path__ + "static/media/icon-trash.4a8316e7.svg";